import { render, staticRenderFns } from "./normal-select.vue?vue&type=template&id=fb4b99be&scoped=true&"
import script from "./normal-select.vue?vue&type=script&lang=ts&"
export * from "./normal-select.vue?vue&type=script&lang=ts&"
import style0 from "./normal-select.vue?vue&type=style&index=0&id=fb4b99be&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4b99be",
  null
  
)

export default component.exports